import React from 'react';
import PropTypes from 'prop-types';

// Multibrand-UI Components
import Text from '@zg-rentals/multibrand-ui/lib/Text';

const propTypes = {
    isPhoneLead: PropTypes.bool,
};

const defaultProps = {
    isPhoneLead: false,
};

const InquiryType = ({ isPhoneLead }) => {
    // TODO: When API response includes hasTourRequest, update inquiry type options
    // TODO: When brand is provided by the backend, update this to include "via {brand}"

    const inquiryType = `${isPhoneLead ? 'Phone ' : ''}Inquiry`;

    return (
        <Text className="InquiryType" lowlight={true} uppercase={true} type="h5">
            {inquiryType}
        </Text>
    );
};

InquiryType.propTypes = propTypes;
InquiryType.defaultProps = defaultProps;

export default InquiryType;
